import apiClient from "../clients/apiClient";
import { ApiResponse } from "../schemas/apiResponseSchema";

export interface ItemUomResponse {
    id: number;
    uom_code: string;
    uom_desc: string;
    allow_decimal: boolean;
    sort_order: number;
    status: number;
}

// All UOMs in dropdown order (inactive included, so an item still on a
// retired UOM can show it); callers offer only status === 1 for new picks.
export const getAllItemUoms = async (): Promise<ItemUomResponse[]> => {
    try {
        const response: ApiResponse<ItemUomResponse[] | null> = (
            await apiClient.get("/pos_item_uom/all", {
                headers: {
                    "x-skip-auth-redirect": "true",
                },
            })
        ).data;

        return response.data || [];
    } catch (error: any) {
        if (error?.response?.status === 401) {
            throw new Error("Not authorized to load item UOMs. Please sign in with backend authentication.");
        }

        if (error?.response?.data?.detail) {
            throw new Error(error.response.data.detail);
        }

        throw new Error("Failed to fetch item UOMs");
    }
};
